import { useSidebar } from "../../context/SidebarContext";

/**
 * Hamburger button that lives in the page header (outside the drawer) and
 * collapses/expands the sidebar into an icon-only rail.
 */
const SidebarToggle = () => {
	const { toggleCollapsed } = useSidebar();
	return (
		<button
			type="button"
			onClick={toggleCollapsed}
			aria-label="Toggle sidebar"
			className="p-2 rounded-md text-secondary hover:bg-gray-100 transition-colors"
		>
			<svg
				className="h-6 w-6"
				fill="none"
				viewBox="0 0 24 24"
				strokeWidth={1.8}
				stroke="currentColor"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M3.75 6.75h16.5M3.75 12h16.5M3.75 17.25h16.5"
				/>
			</svg>
		</button>
	);
};

export default SidebarToggle;
